import { render } from "./QuickEditWishlist.vue?vue&type=template&id=9b5043b0&scoped=true"
import script from "./QuickEditWishlist.vue?vue&type=script&lang=ts"
export * from "./QuickEditWishlist.vue?vue&type=script&lang=ts"

import "./QuickEditWishlist.vue?vue&type=style&index=0&id=9b5043b0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9b5043b0"

export default script